import { aboutData } from "@/mocks/homeData";

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
          <div className="lg:w-2/5 flex-shrink-0">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=warm%20modern%20office%20space%20with%20multiple%20monitors%20displaying%20news%20feeds%2C%20editorial%20newsroom%20atmosphere%2C%20team%20collaboration%2C%20red%20and%20gold%20accents%2C%20cinematic%20lighting%2C%20professional%20setting&width=1000&height=750&seq=about-platform&orientation=landscape"
                alt="51吃瓜网站平台介绍"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>

          <div className="lg:w-3/5">
            <span className="text-xs font-semibold text-primary-500 uppercase tracking-wide">About Us</span>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mt-2 mb-6 font-heading">
              {aboutData.title}
            </h2>
            <div className="space-y-4">
              {aboutData.paragraphs.map((p, i) => (
                <p key={i} className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  {p}
                </p>
              ))}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mt-8">
              <div className="bg-background-100 rounded-xl p-4 text-center border border-background-200/70">
                <div className="text-xl md:text-2xl font-bold text-primary-500 font-heading">50+</div>
                <div className="text-xs text-foreground-600 mt-1">监控平台</div>
              </div>
              <div className="bg-background-100 rounded-xl p-4 text-center border border-background-200/70">
                <div className="text-xl md:text-2xl font-bold text-accent-500 font-heading">15min</div>
                <div className="text-xs text-foreground-600 mt-1">快讯上线</div>
              </div>
              <div className="bg-background-100 rounded-xl p-4 text-center border border-background-200/70">
                <div className="text-xl md:text-2xl font-bold text-primary-500 font-heading">99.7%</div>
                <div className="text-xs text-foreground-600 mt-1">信息准确率</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}